import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.reduce.js";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import attrConvertor from 'react-attr-converter';
var SVGRegExp = /<svg((?:(?!>)[\s\S])*)>([\s\S]*)<\/svg>/im;
var AttrRegExp = /[^=]*=("|')[^"']*("|')/g;

var Svg = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Svg, _React$PureComponent);

  function Svg() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.state = _this.prepare();
    return _this;
  }

  var _proto = Svg.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.content !== this.props.content) {
      this.setState(this.prepare());
    }
  };

  _proto.prepare = function prepare() {
    var match = this.props.content.match(SVGRegExp);

    if (!match) {
      return {};
    }

    return match[1].trim().match(AttrRegExp).reduce(function (attrs, attr) {
      var _attr$split$map = attr.split('=').map(function (str) {
        return str.trim();
      }),
          key = _attr$split$map[0],
          val = _attr$split$map[1];

      if (key === 'class' || key === 'style') {
        return attrs;
      }

      attrs[attrConvertor(key)] = (val || key).replace(/["''"]/g, '');
      return attrs;
    }, {
      dangerouslySetInnerHTML: {
        __html: match[2].trim()
      }
    });
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("svg", Object.assign({}, this.state, {
      className: (this.props.className || '') + " image",
      "data-id": this.props.id,
      style: this.props.style
    }));
  };

  return Svg;
}(React.PureComponent);

export { Svg as default };